export type Formats = (typeof formatsMapper)[keyof typeof formatsMapper];

export const formatsMapper: Record<string, string> = {
  TIPO_VIDEO: 'video',
  TIPO_OCS_VIDEO: 'video',
  VIDEO: 'video',
  TIPO_FILM: 'video',
  FILM: 'video',

  TIPO_AUDIO: 'audio',
  TIPO_OCS_AUDIO: 'audio',
  AUDIO: 'audio',
  TIPO_FINDAWAY: 'audio',
  FINDAWAY: 'audio',

  TIPO_PODCAST: 'podcast',
  PODCAST: 'podcast',

  TIPO_EBOOK: 'ebook',
  TIPO_OCS_EPUB: 'ebook',
  TIPO_OCS_PDF: 'ebook',
  TIPO_STREAMING_PDF: 'ebook',
  TIPO_STREAMING_EPUB: 'ebook',
  CB_DOWNLOAD: 'ebook',
  PDF: 'ebook',
  EBOOK: 'ebook',
  EPUB: 'ebook',
  TIPO_CB_WATERMARK: 'ebook',
  TIPO_CB_ACSM: 'ebook',

  TIPO_NEWSPAPER_OCS: 'newspaper',
  TIPO_NEWSPAPER_EBOOK: 'newspaper',
  TIPO_NEWSPAPER_STREAMING: 'newspaper',
  NEWSPAPER: 'newspaper',

  TIPO_MAGAZINE_OCS: 'magazine',
  TIPO_MAGAZINE_EBOOK: 'magazine',
  TIPO_MAGAZINE_STREAMING: 'magazine',
  MAGAZINE: 'magazine',

  TIPO_ARTICLE: 'article',
  ARTICLE: 'article',

  TIPO_SUMMARY: 'summary',
  SUMMARY: 'summary',

  TIPO_IMAGEN: 'image',
  IMAGE: 'image',

  TIPO_SCORM: 'scorm',
  SCORM: 'scorm',

  TIPO_HTML_STREAMING: 'html',
  TIPO_STREAMING_HTML: 'html',

  ALBUM: 'album',

  LIST: 'list',

  TIPO_FISICO: 'physical',
  PHYSICAL: 'physical',

  TIPO_DATABASE: 'other',
  DATABASE: 'other',
  MUSIC_SHEET: 'other',
  FORMAT_MUSIC_SHEET: 'other',
} as const;
